var _a, _b, _c, _d, _e;
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, connectAuthEmulator, GoogleAuthProvider } from 'firebase/auth';
import { initializeFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';
const DEMO_FIREBASE_CONFIG = {
    apiKey: 'AIzaSyDcxAYG1UxjcCttlWgwJbN9xbyKHA9GNTc',
    authDomain: 'tsf-retro-demo.firebaseapp.com',
    projectId: 'tsf-retro-demo',
    storageBucket: 'tsf-retro-demo.appspot.com',
    messagingSenderId: '599432854128',
    appId: '1:599432854128:web:1264fc02c32c3f88c852b5',
    measurementId: 'G-T4S1YXSY6P',
};
const LIVE_FIREBASE_CONFIG = {
    apiKey: 'AIzaSyDulsU8AD27wk2c_pOB-a2jvQIeEXEkE7A',
    authDomain: 'tsf-retro.firebaseapp.com',
    projectId: 'tsf-retro',
    storageBucket: 'tsf-retro.appspot.com',
    messagingSenderId: '986110208097',
    appId: '1:986110208097:web:7526899da67d035f0d6220',
    measurementId: 'G-55QNTZNM09',
};
function getConfig(environment) {
    switch (environment) {
        case 'DEMO':
            return DEMO_FIREBASE_CONFIG;
        case 'LIVE':
            return LIVE_FIREBASE_CONFIG;
        default:
            throw new Error('Invalid environment set');
    }
}
function getFirebaseFunctionsLocation(environment, emulated) {
    if (emulated) {
        return `http://localhost:5002/tsf-retro-demo/europe-west2/`;
    }
    switch (environment) {
        case 'DEMO':
            return 'https://europe-west2-tsf-retro-demo.cloudfunctions.net/';
        case 'LIVE':
            return 'https://europe-west2-tsf-retro.cloudfunctions.net/';
        default:
            throw new Error('Invalid environment set');
    }
}
const firebaseConfig = getConfig((_a = process.env.APP_ENV) !== null && _a !== void 0 ? _a : 'DEMO');
if (getApps().length === 0) {
    initializeApp(firebaseConfig);
}
const app = getApps()[0];
export const FirebaseFunctionsLocation = getFirebaseFunctionsLocation((_b = process.env.APP_ENV) !== null && _b !== void 0 ? _b : 'DEMO', (_c = process.env.EMULATED_FIREBASE) !== null && _c !== void 0 ? _c : 'true');
export const auth = getAuth(app);
export const db = initializeFirestore(app, { ignoreUndefinedProperties: true });
export const googleProvider = new GoogleAuthProvider();
export const functions = getFunctions(app, 'europe-west2');
export const analytics = getAnalytics(app);
export { app as firebase };
if (process.env.EMULATED_FIREBASE) {
    console.log('Running in emulation mode for dev and testing');
    const hostname = (_e = (_d = window === null || window === void 0 ? void 0 : window.location) === null || _d === void 0 ? void 0 : _d.hostname) !== null && _e !== void 0 ? _e : 'localhost';
    connectFirestoreEmulator(db, hostname, 8080);
    connectAuthEmulator(auth, `http://${hostname}:9099`);
    connectFunctionsEmulator(functions, hostname, 5002);
}
